<template>
  <menu-layout-dynamic>
    <div class="container">
      <div class="menu-switch">
        <div class="item">
          <gl-button
            :primary="visibleMenuType === 'idpos'"
            @click="setVisibleMenuType('idpos')"
            :disabled="!idposEnabled"
          >
            ID-POS
          </gl-button>
          <md-tooltip v-if="!idposEnabled">
            ID-POS分析のご契約がないようです…
          </md-tooltip>
        </div>
        <div class="item">
          <gl-button
            :primary="visibleMenuType === 'pos'"
            @click="setVisibleMenuType('pos')"
            :disabled="!posEnabled"
          >
            POS
          </gl-button>
          <md-tooltip v-if="!posEnabled">
            POS分析のご契約がないようです…
          </md-tooltip>
        </div>
        <div class="item" title="最近使ったメニュー">
          <gl-button
            icon-button
            dense
            :primary="visibleMenuType === 'recent'"
            @click="setVisibleMenuType('recent')"
          >
            <gl-icon-history />
          </gl-button>
        </div>
      </div>
      <div>
        <transition-group tag="div" class="menus">
          <div
            class="menu-container"
            v-for="menu in visibleMenus"
            :key="menu.menuCode"
          >
            <menu-item
              :menu="menu"
              :show-data-type-ribbon="visibleMenuType === 'recent'"
              @click="moveToQuery(menu)"
              :size="menuItemSize"
            ></menu-item>
          </div>
        </transition-group>
        <div
          v-if="visibleMenuType === 'recent' && visibleMenus.length === 0"
          class="no-history"
        >
          まだ分析履歴がありません。さっそく分析を行いましょう！
        </div>
      </div>
    </div>
  </menu-layout-dynamic>
</template>

<script>
import woothee from 'woothee'
import MenuLayout from '@/components/layout/MenuLayout.vue'
import MenuItem from '@/components/MenuItem.vue'
import { SET_MENU_DATA_TYPE } from '@/const/mutation-types'

const BROWSER = (woothee.parse(window.navigator.userAgent) || {}).name

export default {
  components: { MenuItem },
  name: 'app',
  data() {
    return {
      history: [],
      visibleMenuMode: 'all',
      visibleMenuType: 'idpos',
      windowHeight: 0,
      scrollElem: ['Edge'].includes(BROWSER)
        ? document.body
        : document.getElementsByTagName('html')[0],
    }
  },
  computed: {
    /**
     * ログインユーザーが閲覧可能なメニュー
     */
    availableMenus() {
      return this.$store.state.menus
    },
    visibleMenus() {
      switch (this.visibleMenuType) {
        case 'idpos':
          return this.$store.state.idposMenus
        case 'pos':
          return this.$store.state.posMenus
        case 'recent':
          return this.history
            .map(h => this.availableMenus.find(m => m.menuCode === h))
            .filter(m => m)
      }
      return []
    },
    idposEnabled() {
      return this.$store.state.account.services.includes('idpos')
    },
    posEnabled() {
      return this.$store.state.account.services.includes('pos')
    },
    menuItemSize() {
      const MAX_SIZE = 300
      const MIN_SIZE = 150

      const pageHeight = this.windowHeight
      const headerHeight = 112 // TODO どうやって取る？
      const footerHeight = 227 // TODO どうやって取る？

      let size = pageHeight - (headerHeight + footerHeight)

      if (size > MAX_SIZE) {
        size = MAX_SIZE
      } else if (size < MIN_SIZE) {
        size = MIN_SIZE
      }

      return size
    },
  },
  methods: {
    /**
     * 分析画面に遷移する
     *
     * 分析画面のパスは、`/query-${menu.menuCode}`のルール
     */
    async moveToQuery(menu) {
      window.open(`${process.env.BASE_URL}query-${menu.menuCode}`)
      await this.$menuHistory.add(menu.menuCode)
      this.history = await this.$menuHistory.get()
    },
    /**
     * 表示データ種別設定
     */
    setVisibleMenuType(menuType) {
      this.visibleMenuType = menuType
      this.$store.commit(SET_MENU_DATA_TYPE, this.visibleMenuType)
    },
  },
  created() {
    this.$emit('update-layout', {
      component: MenuLayout,
    })

    this.windowHeight = window.innerHeight

    this.$windowResize.subscribe(windowSize => {
      this.windowHeight = windowSize.windowHeight
    })

    // マウスホイール操作を横スクロールに変換する
    window.addEventListener('wheel', e => {
      // ブラウザによってdeltaYの値が結構違うので、一回のホイールイベントで移動する
      // 量は固定にする
      const amount = e.deltaY > 0 ? 100 : -100
      this.scrollElem.scrollLeft += amount
    })

    if (
      this.$store.state.account.services.includes(this.$route.query.service)
    ) {
      this.visibleMenuType = this.$route.query.service
    }
    if (!this.idposEnabled) {
      this.visibleMenuType = 'pos'
    }

    this.$store.commit(SET_MENU_DATA_TYPE, this.visibleMenuType)
  },
  async mounted() {
    this.history = await this.$menuHistory.get()
  },
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
}

.menu-switch {
  width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .item {
    margin-top: 10px;

    &:first-child {
      margin-top: 0;
    }
  }
}

.menus {
  display: flex;
}

.menu-container {
  margin-right: var(--spacing-medium);
}

.no-history {
  color: var(--color-secondary-text);
  font-size: var(--font-size-xlarge);
  margin-top: var(--spacing-large);
}

// Menu transition animation
.menu-container {
  transition: all 0.5s;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
.v-enter {
  transform: translateY(-150px);
}
.v-leave-to {
  transform: translateY(150px);
}
.v-leave-active {
  position: absolute;
}
</style>
